import React, { useState, useEffect } from "react";
import UpArrow from '../assets/up-arrow.svg'
import '../styles/backtotop.css'

const BackToTop = () => {
    const [isVisible, setIsVisible] = useState(false);

    // Show button when user scrolls down
    useEffect(() => {
        const toggleVisibility = () => {
            if (window.scrollY > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener("scroll", toggleVisibility);
        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    // Scroll to top function
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        <button className="back-to-top-btn" 
            onClick={scrollToTop} 
            style={{ display: isVisible ? "block" : "none"
               
            }}
        >
            <img src={UpArrow} alt="back-to-top" />
        </button>
    );
};

export default BackToTop;
